import React, { PropTypes } from 'react';

const Timer = ({ time, className }) => {
  return (
    <div className={className} style={{fontSize: '18px'}}>
      <span>
        {("0" + Math.floor((time / 60000) % 60)).slice(-2)}:
      </span>
      <span>
        {("0" + Math.floor((time / 1000) % 60)).slice(-2)}
      </span>
    </div>
  );
}

Timer.propTypes = {
  time: PropTypes.number,
};

export default Timer;
